import ReportsRouter from './Reports.router';
export { default as reportsRoutes } from './routes';

export default ReportsRouter;
